import { RootState } from '../core/redux/store';
import { selectWindowsInViewport } from './redux/windowsSlice';
import { connect } from 'react-redux';
import useMasterWinSize from './hooks/useMasterWinSize';
import WindowsInViewport from './components/templates/WindowsInViewport';

interface WindowsProps {
  windowsInViewport: string[];
  activeWindow: string;
}

const Windows: React.FC<WindowsProps> = ({
  windowsInViewport,
  activeWindow,
}) => {
  const { topSectionSum, bottomSectionSum, maxSize } = useMasterWinSize();

  return (
    <WindowsInViewport
      windows={windowsInViewport}
      activeWindow={activeWindow}
      topSectionSum={topSectionSum}
      bottomSectionSum={bottomSectionSum}
      maxHeight={maxSize.height}
      maxWidth={maxSize.width}
    />
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    windowsInViewport: selectWindowsInViewport(state),
    activeWindow: state.windows.activeWindow,
  };
};

export default connect(mapStateToProps)(Windows);
